import React from 'react';
import Card from '../base/Card';
import Button from '../base/Button';
import './PlaceholderStyles.css';

function FocusTimerPlaceholder() {
  return (
    <div className="placeholder-container">
      <Card className="placeholder-card feature-placeholder">
        <div className="placeholder-icon">⏱️</div>
        <h2 className="placeholder-title title-1">Focus Timer</h2>
        <p className="placeholder-description body-text">
          Your main focus timer with customizable durations, break intervals, and session tracking.
          Built with the Pomodoro technique in mind, adapted for deep work.
        </p>
        <div className="placeholder-features">
          <div className="feature-item">
            <span className="feature-check">✓</span>
            <span className="feature-text">Customizable work sessions</span>
          </div>
          <div className="feature-item">
            <span className="feature-check">✓</span>
            <span className="feature-text">Smart break reminders</span>
          </div>
          <div className="feature-item">
            <span className="feature-check">✓</span>
            <span className="feature-text">Session history tracking</span>
          </div>
        </div>
        <div className="placeholder-actions">
          <Button variant="primary" showArrow disabled>
            Start Building Timer
          </Button>
        </div>
        <p className="placeholder-note caption">
          Ready for implementation. Replace this component with your timer logic.
        </p>
      </Card>
    </div>
  );
}

export default FocusTimerPlaceholder;








